import React from "react";
import { Col } from "react-bootstrap";

export default function Counter(props) {
  return (
    <Col xs={12} sm={6} md={3} className="counter-box">
      <p className="dark-red fs-16 fw-bold text-uppecase mb-3">{props.Title}</p>
      <h2 className="white-mode  fs-32 fw-bold text-uppecase mb-0">{props.Count}</h2>
      <p className="gold-color fs-20 fw-bold text-uppecase mb-1">{props.CountTitle}</p>

    </Col>
  );
}

